import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { peformanceBySKU: { getPerformanceBySKU } } = apiUrls;

export const PERFORMANCE_BY_SKU_SUCCESS = 'PERFORMANCE_BY_SKU_SUCCESS';
export const PERFORMANCE_BY_SKU_LOADING = 'SALES_CATEGORY_BY_MONTH_LOADING';

export const getPerformanceBySKUData = ({ fromDate, toDate, sku }) => async (dispatch) => {

    try {        
            const requestData = {
                ...getPerformanceBySKU,
                url: getPerformanceBySKU.url.replace('{from}', fromDate).replace('{to}', toDate).replace("{sku}", sku)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: PERFORMANCE_BY_SKU_SUCCESS,
                data                
            })

    } catch (e) {

        dispatch({
            type: PERFORMANCE_BY_SKU_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }            
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {   
        dispatch({
            type: PERFORMANCE_BY_SKU_LOADING,
            isLoading            
        });   
}